module.exports = __webpack_public_path__ + "static/media/Abdul.624fb187.png";